<div class="row">
  <!--<div class="col-md-12">
      <div *ngIf="fullScreenWindowOptions.isSortByOpen" class="menu-header">
          <a href="javascript:void(0)" class="closebtnfilters" (click)="closeNav('closeSortBy')">&times;</a>
          <span class="sort-btn-mobile">Sort</span>
      </div>
      <div *ngIf="fullScreenWindowOptions.isFilterOptionsOpen" class="menu-header">
          <a href="javascript:void(0)" class="closebtnfilters" (click)="closeNav('closeFilters')">&times;</a>
          <span class="filter-btn-mobile" (click)="openFilterMenu()">Filter</span>
      </div>
  </div>
</div>

<div *ngIf="fullScreenWindowOptions.isSortByOpen" id="filterWrap" 
      class="overlay-content">
  <div class="sortbyoptions">
    <label class="container">Experiences
      <input type="radio" value="exclusives" checked="checked" name="radio" [(ngModel)]="selecteOption"
        (change)="onChangeFilter($event)">
      <span class="checkmark"></span>
    </label>
    <label class="container">Price high to low
      <input type="radio" value="price_high_low" name="radio" [(ngModel)]="selecteOption"
          (change)="onChangeFilter($event)">
      <span class="checkmark"></span>
    </label>
    <label class="container">Price low to high
      <input type="radio" value="price_low_high" name="radio" [(ngModel)]="selecteOption"
          (change)="onChangeFilter($event)">
      <span class="checkmark"></span>
    </label>
 </div>
</div>
             
<div *ngIf="!fullScreenWindowOptions.isSortByOpen" id="filterWrap" [ngStyle]=" stickySidebar.stickySidebarEnabled? {'position': stickySidebar.position, 'top': stickySidebar.top + 'px', 'width': stickySidebar.width + 'px', 'bottom': stickySidebar.bottom + 'px'}: ''" 
      class="overlay-content sidebar-item">
  <div class="make-me-sticky">
    <div class="filter mobile-hidden">
      <h4>Sort By</h4>
      <div id="sorting">
          <div class="selectOptions" >
            <select [(ngModel)]="selecteOption" (ngModelChange)="onChangeFilter($event)">
              <option value="price_low_high">Price low to high</option>
              <option value="price_high_low">Price high to low</option>
              <option value="special_offer">Special offer expires in</option>
              <option value="exclusives">Experiences</option>
            </select>
          </div>
      </div>
    </div>-->
    <!--<div class="filter">
      <h4>Daily Price</h4>
      <div class="priceSlider">
        <span id="filterMinPrice">€{{someRange[0]}}</span>
        <div id="filter-slider-range-sidebar">
            <nouislider [connect]="true" [min]="minPrice" [max]="maxPrice" [step]="1" [(ngModel)]="someRange"
            (ngModelChange)="onChange($event)" (end)="filterByPrice()"></nouislider>
        </div>
        <span id="filterMaxPrice">€{{someRange[1]}}</span>
      </div>
      <button>Done</button>
    </div>-->
    <div class="filter filterOffers" id="sideOfferFilter" style="margin-left:-10px;">
      <h4>Daily Price (Offers)</h4>
      <div class="priceSlider">
        <span id="filterMinPrice">€{{ minPriceOffer }}</span>
        <div id="filter-slider-range-sidebarOffers">
            <nouislider [connect]="true" [min]="minPriceOfferSlider" [max]="maxPriceOfferSlider" [step]="1" 
            [(ngModel)]="someRangeOffers" (ngModelChange)="onChangeOfferFilter($event)"></nouislider>
        </div>
        <span id="filterMaxPrice">€{{ maxPriceOffer }}</span>
      </div>
      <button (click)="filterByPriceOffers()">Done</button>
    </div>
    <!--<div class="filter" id="bookingRequestExtras" style="margin-left:-10px;">
      <h4>Experiences</h4>
      <p *ngIf="experiences.length === 0" style="margin-top:10px; margin-left: 10px;color: #406a71;
          font-size: 15px;">No Experiences Selected
      </p>
      <div class="types">
        <div class="types">
          <mat-button-toggle-group [vertical]=true>
            <mat-button-toggle *ngFor="let exp of experiences" class="type" (click)="filterByExpOffers(exp)">{{ exp }}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
  </div>-->
  
  <!--<div class="filter" id="bookingRequestExtras">
    <h4>Exclusive categories</h4>
    <div class="types">
        <div class="types">
            <mat-button-toggle *ngFor="let key of getKeys(exclusiveCategories)" (click) = "filterbyExclusive(key)"
            class="type">{{exclusiveCategories.get(key)}}</mat-button-toggle>
        </div>
    </div>
  </div>-->

</div>
